export default "__VITE_ASSET__sQVplCWW__"